<template>
  <div>
    <ApolloQuery
      :query="require('../graphql/Entidades.gql')"
      :clientId="client"
      :update="data => {
        return data.entidades
      }"
      :debounce="500"
    >
      <template slot-scope="{ result: { loading, error, data } }">
        <!-- Loading -->
        <div v-if="loading">Listando entidades...</div>

        <!-- Error -->
        <div v-else-if="error">{{ error.message }}</div>

        <!-- Result -->
        <div v-else-if="data">
          <b-field label="Município">
            <b-select 
                v-model.number="entidade"
                placeholder="Selecione o município">
              <option
                v-for="option in data"
                :value="option.id"
                :key="option.id"
              >{{ option.nome }}</option>
            </b-select>
          </b-field>
          <!-- <obras-servicos v-if="!!entidade" :all="all" :entidade="entidade"></obras-servicos> -->
          <obras-servicos-details v-if="!!entidade" :all="all" :entidade="entidade"></obras-servicos-details>
          <!-- <pre>
            {{
              data
            }}
          </pre> -->
        </div>

        <!-- No result -->
        <div v-else class="alert alert-warning">Listando entidades...</div>
      </template>
    </ApolloQuery>
  </div>
</template>

<script>
export default {
  data() {
    return {
      entidade: null
    };
  },
  props: {
    all: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    client() {
      return this.all ? 'v2' : 'v1'
    }
  },
  components: {
    // ObrasServicos: () => import("./ObrasServicos.vue"),
    ObrasServicosDetails: () => import("./ObrasServicosDetails.vue")
  }
};
</script>